import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as requestUpdateActions from 'features/request-update/duck';
import * as notificationsActions from 'features/notifications/duck';
import { ModalInfo, AlertNotice, Textarea, MultiRadio, AlertMessage } from 'shared/components';
import { REQUEST_UPDATE_TYPE, REQUEST_UPDATE_STATUS } from 'shared/constants';
import { REASON_OPTIONS } from '../constants';
import { isEmpty, isEqual } from 'lodash';
import { mapEventReschedule } from 'features/request-update/selectors';
import CloseCircle from 'assets/svgs/closeCircle.svg';
import ReviewRescheduleTC from './review-reschedule-tc/ReviewRescheduleTC';
import './RequestRescheduleEvent.scss';
import PendingIcon from 'assets/svgs/pendingIcon.svg';

const MESSAGE_MAX_LENGTH = 360;

const rescheduleReasonOptions = [
  {
    label: 'Inclement weather',
    key: 'weather',
    name: 'weather',
    value: REASON_OPTIONS.inclementWeather,
  },
  {
    label: 'Other',
    key: 'other',
    name: 'other',
    value: REASON_OPTIONS.other,
  },
];
class RequestRescheduleEvent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      rescheduleModalOpen: false,
      selectedReason: REASON_OPTIONS.inclementWeather,
      reason: props.eventReschedule.reason,
      dates: props.eventReschedule.dates,
      showReviewRequest: false,
      showAlertMessage: false,
      alertMessage: '',
      error: {
        reason: '',
      },
      eventRescheduleData: props.eventReschedule,
    };

    this.onReasonOptionChange = this.onReasonOptionChange.bind(this);
    this.onTextChange = this.onTextChange.bind(this);
    this.onClearValue = this.onClearValue.bind(this);
    this.onSubmitRequest = this.onSubmitRequest.bind(this);
    this.onGoBack = this.onGoBack.bind(this);
    this.removeAlertMessage = this.removeAlertMessage.bind(this);
    this.cancelRequest = this.cancelRequest.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { eventReschedule } = this.props;

    if (!isEqual(prevProps.eventReschedule, eventReschedule)) {
      this.setState({
        reason:
          eventReschedule.reason &&
          eventReschedule.reason.toLowerCase() !== REASON_OPTIONS.inclementWeather.toLowerCase()
            ? eventReschedule.reason
            : '',
        dates: eventReschedule.dates,
        selectedReason:
          !eventReschedule.reason ||
          eventReschedule.reason.toLowerCase() === REASON_OPTIONS.inclementWeather.toLowerCase()
            ? REASON_OPTIONS.inclementWeather
            : REASON_OPTIONS.other,
      });
    }
  }

  onReasonOptionChange(e) {
    this.setState({
      selectedReason: e.target.value,
      error: {
        reason: '',
      },
    });
  }

  onTextChange(e) {
    const { name, value } = e.target;

    this.setState((prevState) => ({
      [name]: value,
      error: {
        ...prevState.error,
        [name]: '',
      },
    }));
  }

  onClearValue(name) {
    this.setState({
      [name]: '',
    });
  }

  removeAlertMessage() {
    this.setState({
      showAlertMessage: false,
    });
  }

  async onSubmitRequest() {
    const { showReviewRequest, selectedReason, reason, dates, eventRescheduleData } = this.state;
    const { actions, currentRequest, tcEvent, testCenterCycle, userId } = this.props;

    if (selectedReason === REASON_OPTIONS.other && isEmpty(reason)) {
      this.setState({
        error: {
          reason: 'requestUpdate.rescheduleTCModal.errorRequiredReason',
        },
      });
      return;
    } else {
      this.setState({
        eventRescheduleData: {
          reason: selectedReason === REASON_OPTIONS.other ? reason : selectedReason,
          dates: dates,
        },
      });
    }

    if (showReviewRequest) {
      const data = {
        testCenterId: testCenterCycle.testCenterProgram.testCenter.id,
        testingEventId: tcEvent.testingEvent.id,
        type: REQUEST_UPDATE_TYPE.rescheduleTcEvent,
        data: {
          eventReschedule: eventRescheduleData,
        },
      };

      if (currentRequest.id) {
        await actions.updateRequest({ ...data, id: currentRequest.id });
      } else {
        await actions.createRequest(data);
      }
      actions.getRequestUpdate(
        testCenterCycle.testCenterProgram.testCenter.id,
        tcEvent.testingEvent.id
      );
      actions.getNotViewedNotificationsCount(userId);
      this.props.toggleModal();
      this.setState({
        showAlertMessage: true,
        alertMessage: 'requestUpdate.review.successMessage',
        showReviewRequest: false,
      });
    } else {
      this.setState({
        showReviewRequest: true,
      });
    }
  }

  onGoBack(closeModal) {
    const { eventReschedule } = this.props;

    this.setState({
      showReviewRequest: false,
    });
    if (closeModal || !this.state.showReviewRequest) {
      this.setState({
        reason:
          eventReschedule.reason &&
          eventReschedule.reason.toLowerCase() !== REASON_OPTIONS.inclementWeather.toLowerCase()
            ? eventReschedule.reason
            : '',
        dates: eventReschedule.dates,
        selectedReason:
          !eventReschedule.reason ||
          eventReschedule.reason.toLowerCase() === REASON_OPTIONS.inclementWeather.toLowerCase()
            ? REASON_OPTIONS.inclementWeather
            : REASON_OPTIONS.other,
        error: {},
      });
      this.props.toggleModal(true);
    }
  }

  async cancelRequest() {
    const { testCenterCycle, tcEvent } = this.props;

    await this.props.actions.updateRequest({
      testCenterId: testCenterCycle.testCenterProgram.testCenter.id,
      testingEventId: tcEvent.testingEvent.id,
      status: REQUEST_UPDATE_STATUS.cancelled,
    });
    this.onGoBack(true);

    this.setState({
      showAlertMessage: true,
      alertMessage: 'requestUpdate.cancelRequest.successRescheduleTcEvent',
    });
    this.props.actions.getRequestUpdate(
      testCenterCycle.testCenterProgram.testCenter.id,
      tcEvent.testingEvent.id
    );
  }

  render() {
    const {
      selectedReason,
      showReviewRequest,
      showAlertMessage,
      dates,
      reason,
      error,
      eventRescheduleData,
      alertMessage,
    } = this.state;

    const { rescheduleModalOpen, errorUpdateRequest, currentRequest } = this.props;
    const pendingRescheduleRequest =
      currentRequest.id && currentRequest.type === REQUEST_UPDATE_TYPE.rescheduleTcEvent;

    return (
      <>
        <ModalInfo
          containerClass="modal-reschedule-event-container"
          className="modal-reschedule-event"
          modalIsOpen={rescheduleModalOpen}
          closeModal={() => this.onGoBack(true)}
          onSubmit={this.onSubmitRequest}
          onCancel={() => this.onGoBack(false)}
          headerTitle={this.props.t('requestUpdate.title')}
          saveLabel={this.props.t(
            `${
              showReviewRequest ? 'requestUpdate.review.submitBtn' : 'requestUpdate.reviewBtnLabel'
            }`
          )}
          cancelLabel={this.props.t(
            `${showReviewRequest ? 'requestUpdate.review.goBackBtn' : 'common.labels.back'}`
          )}
          showCancel>
          {showReviewRequest ? (
            <div>
              <h5 className="mb-3">{this.props.t('requestUpdate.review.title')}</h5>
              <AlertNotice message={this.props.t('requestUpdate.review.infoMessage')} />
              <ReviewRescheduleTC eventReschedule={eventRescheduleData} />
            </div>
          ) : (
            <div>
              <h4 className="mb-3">
                {this.props.t('requestUpdate.rescheduleTCModal.title')}
                {pendingRescheduleRequest && (
                  <>
                    {' '}
                    -{' '}
                    <span className="no-wrap">
                      {this.props.t('requestUpdate.rescheduleTCModal.pending')} <PendingIcon />
                    </span>
                  </>
                )}
              </h4>
              <AlertNotice message={this.props.t('requestUpdate.rescheduleTCModal.infoMessage')} />
              {pendingRescheduleRequest && (
                <div className="border-bottom-gray border-top-gray margin-b-20">
                  <button
                    className="btn-link cancel-reschedule-button"
                    onClick={this.cancelRequest}>
                    <CloseCircle />
                    <span className="ps-1">
                      {this.props.t('requestUpdate.rescheduleTCModal.cancelRequestLabel')}
                    </span>
                  </button>
                </div>
              )}
              <div className="border-bottom-gray pb-3">
                <MultiRadio
                  title={this.props.t('requestUpdate.rescheduleTCModal.rescheduleReasonLabel')}
                  radioList={rescheduleReasonOptions}
                  checkedValue={selectedReason}
                  onChange={this.onReasonOptionChange}
                />
                {selectedReason === REASON_OPTIONS.other && (
                  <Textarea
                    value={reason}
                    name="reason"
                    containerClassName="reason-textarea-container"
                    label="requestUpdate.rescheduleTCModal.otherReasonLabel"
                    maxLength={MESSAGE_MAX_LENGTH}
                    onChange={this.onTextChange}
                    clearValue={() => this.onClearValue('reason')}
                    isValueChanged={!!reason}
                    error={error.reason}
                  />
                )}
              </div>
              <Textarea
                value={dates}
                name="dates"
                label="requestUpdate.rescheduleTCModal.rescheduleDatesLabel"
                labelInfo={this.props.t('requestUpdate.rescheduleTCModal.rescheduleDateInfoLabel')}
                maxLength={MESSAGE_MAX_LENGTH}
                onChange={this.onTextChange}
                clearValue={() => this.onClearValue('dates')}
                isValueChanged={!!dates}
              />
            </div>
          )}
        </ModalInfo>
        <AlertMessage
          show={showAlertMessage}
          removeMessage={this.removeAlertMessage}
          message={errorUpdateRequest ? 'errors.somethingWentWrong' : alertMessage}
          isError={errorUpdateRequest}
        />
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    tcEvent: state.tcEvent.currentEvent,
    testCenterCycle: state.tcEvent.testCenterCycle,
    errorUpdateRequest: state.requestUpdate.errorUpdateRequest,
    currentRequest: state.requestUpdate.currentRequest,
    eventReschedule: mapEventReschedule(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...notificationsActions, ...requestUpdateActions }, dispatch),
  };
}

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(RequestRescheduleEvent)
);

RequestRescheduleEvent.propTypes = {
  tcEvent: PropTypes.shape({}).isRequired,
  testCenterCycle: PropTypes.shape({}).isRequired,
  currentRequest: PropTypes.shape({}),
  eventUpdate: PropTypes.shape({}),
  t: PropTypes.func.isRequired,
};

RequestRescheduleEvent.defaultProps = {};
